<template>
  <div dark>
    <v-container class="pa-0">
      <v-row>
        <v-col cols="12" md="3" lg="2">
          <sportsbook-category
            :class="{
              'pt-0': $breakpoint.mdAndUp,
              'pa-0 ': $breakpoint.smAndDown
            }"
            :orientation="$breakpoint.smAndDown ? 'horizontal' : 'vertical'"
          ></sportsbook-category>
        </v-col>
        <v-col cols="12" md="9" lg="10">
          <div class="mt-5 justify-center d-flex">
            <v-card
              to="/"
              color="transparent"
              plan
              :ripple="false"
              elevation="0"
            >
              <v-img :width="150" :src="getLogo($vuetify.theme)"></v-img>
            </v-card>
          </div>

          <div class="mt-3 justify-center align-center d-flex">
            <v-card-text class="text-center">
              <h2>Event Finished</h2>
              <h3 style="opacity: 0.7" class="py-2">
                The event viewed is finished or no longer available
              </h3>
              <v-btn color="primary" to="/">
                <h3>TO MAIN PAGE</h3>
              </v-btn>
            </v-card-text>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import SportsbookCategory from '@/components/sections/SportsbookCategory'
export default {
  components: {
    SportsbookCategory
  }
}
</script>
<style scoped>
.v-card:before {
  opacity: 0 !important;
}
</style>
